(() => {
  function initialize(root = document) {
    for (const video of root.querySelectorAll('[data-pcp-expert195]')) {
      if (!(video instanceof HTMLVideoElement) || video.dataset.sourceSelected) continue;
      const portrait = window.matchMedia('(max-width: 749px)').matches;
      const source = portrait ? video.dataset.mobile : video.dataset.desktop;
      if (!source) continue;
      video.src = source;
      const poster = portrait ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (poster) video.poster = poster;
      video.dataset.format = portrait ? 'portrait' : 'landscape';
      video.dataset.sourceSelected = 'true';
      video.hidden = false;
    }
  }
  initialize();
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  }
})();
